import { render, staticRenderFns } from "./NewVariantAdd.vue?vue&type=template&id=de1b9de2&scoped=true"
import script from "./NewVariantAdd.vue?vue&type=script&lang=js"
export * from "./NewVariantAdd.vue?vue&type=script&lang=js"
import style0 from "./NewVariantAdd.vue?vue&type=style&index=0&id=de1b9de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1b9de2",
  null
  
)

export default component.exports